import moment from "moment";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { AiFillEdit } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const DocumentTable = ({ setEditMode }) => {
  const selector = useSelector((state) => state.business);
  const selectorAuth = useSelector((state) => state.auth);

  const columnDefs = useMemo(() => {
    const cols = [];
    if (selectorAuth?.user?.role === 'super_admin') {
      cols.push({
        field: 'patient_id',
        headerName: 'Id',
        width: 100,
        cellRenderer: (params) => (
          <Link to={"/business/" + params.value} style={{ color: '#1976d2' }}>
            {params.value}
          </Link>
        )
      });
    }
    cols.push(
      {
        field: 'full_name',
        headerName: 'Document Name',
        flex: 1,
        minWidth: 150
      },
      {
        field: 'joined',
        headerName: 'Upload Date',
        flex: 1,
        minWidth: 150,
        valueFormatter: (params) => moment(params.value).format("DD-MM-YYYY")
      },
      {
        field: 'email',
        headerName: 'Url',
        flex: 1,
        minWidth: 150,
        valueFormatter: (params) => params.value === '' ? '-' : params.value
      },
      {
        field: 'actions',
        headerName: 'Actions',
        width: 150,
        cellRenderer: (params) => {
          return (
            <span className="flex gap-4 justify-center items-center">
              <AiFillEdit
                className="cursor-pointer"
                onClick={() => setEditMode(params.data)}
              />
              <MdDelete color='red' className="cursor-pointer" />
            </span>
          );
        },
        sortable: false,
        filter: false
      }
    );
    return cols;
  }, [selectorAuth?.user?.role]);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    filter: true,
    resizable: true
  }), []);

  return (
    <div className="ag-theme-alpine" style={{ height: '400px', width: '100%', padding: '16px' }}>
      <AgGridReact
        rowData={selector?.documents || []}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        pagination={true}
        paginationPageSize={10}
        animateRows={true}
      />
    </div>
  );
};

export default DocumentTable;
